import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, switchMap} from 'rxjs/operators';
import {
    AuthenticatedSuccessAction,
    LoadedAction,
    LoadedSuccessAction,
    RedirectedUrlAction,
    RedirectedUrlSuccessAction,
    UserActionTypes,
} from './user.actions';

@Injectable()
export class UserEffects {

    public authenticated = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(UserActionTypes.AUTHENTICATED),
                switchMap(() => [new AuthenticatedSuccessAction()])
            )
    });

    public redirectedUrl = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(UserActionTypes.REDIRECTED_URL),
                map((actionType: RedirectedUrlAction) => actionType.payload),
                switchMap((payload) => [new RedirectedUrlSuccessAction(payload)])
            )
    });

    public loaded = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(UserActionTypes.LOADED),
                map((actionType: LoadedAction) => actionType.payload),
                switchMap(payload => [new LoadedSuccessAction(payload)])
            )
    });

    constructor(
        private actions$: Actions
    ) {
    }
}
